import * as React from 'react';
import { Header } from './components/Header';
import { ScanSessions } from './components/ScanSessions';
import { useInventoryManagement } from './useInventoryManagement';
import './index.css';

const InventoryManagement = () =>
{
  const {inventory, isHqUser, loading, error, refetch} = useInventoryManagement();

  if (loading)
  {
    return (
      <div className="inventory-management-loading">
        <div className="inventory-management-loading-text">Loading inventory details...</div>
      </div>
    );
  }

  if (error)
  {
    return (
      <div className="inventory-management-error">
        <div className="inventory-management-error-text">Error loading inventory details</div>
      </div>
    );
  }

  if (!inventory)
  {
    return (
      <div className="inventory-management-not-found">
        <div className="inventory-management-not-found-text">Inventory not found</div>
      </div>
    );
  }

  // Get posId from changeStoreParams (selected via Change Store button in Topbar)
  const changeStoreParams = JSON.parse(localStorage.getItem('changeStoreParams'));
  const posId = inventory?.posId || changeStoreParams?.selectedPosId;

  return (
    <div className="inventory-management-page">
      <Header inventory={inventory} posId={posId} isHqUser={isHqUser}/>
      <ScanSessions
        inventoryId={inventory.id}
        sessionCount={inventory.totalSessions || 0}
        sessions={inventory.sessions || []}
        posId={inventory.posId || posId}
        onSessionCreated={refetch}
        inventoryStatus={inventory.status}
      />
    </div>
  );
};

export default InventoryManagement;
